let zeroTrust = {
    title: "零信任办公",
    downFTSafe:"下载FT SafeLogin客户端",
    nowDownLoad:"立即下载，开启无边界安全办公之旅",
    windows:"Windows 客户端",
    clickDown:"点击下载",
    MacDown:"Mac 客户端",
    comming:"敬请期待",
    androidDown:"Android 客户端",
    codeDown:"扫码下载",
    iosDownload:"iOS 客户端",
    codeDown2:"扫码下载",
    editionNum:"版本号：3.14.7.423",
    clientDown:"客户端下载",
    baseOnOwnSystem:"根据自身系统选择下载安装客户端",
    accountLogin:"账号登录",
    IAMquickly:"与IAM打通，使用门户账号认证体系可快速登录",
    zeroTrust:"零信任办公",
    neiwaiNet:"内外网打通，即使在家办公、移动办公，也能安全接入公司内网啦",
    unifiedPortal:"统一门户",
    unifiedEnter:"统一业务资源访问入口，客户端可直接访问资源",
    dataSecurity:"数据安全",
    yeWuYinShen:"业务隐身，暴露面收缩，减少攻击，资源更安全",
    
  }
export default zeroTrust
